<template>
  <div
    class="mobile-menu"
    @click="open"
  >
    <div class="mobile-menu__title">{{ props.title }}</div>
    <Chevron class="mobile-menu__icon" />
  </div>
  <UiModal
    :is-shown="isOpen"
    :title="props.title"
    class="modal-menu"
    is-footer-hidden
    @close="close"
  >
    <template #content>
      <div class="mobile-menu-list">
        <MenuItem
          v-for="item in props.menu"
          :key="item.slug"
          class="mobile-menu-item"
          :item="item"
          :route-start="props.routeStart"
          :active-item-slug="activeItemSlug"
          @close="close"
        />
      </div>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
  import { UiModal } from '@experience/core-modal-ui';
  import type { IMenuItem } from './menu.types';
  import MenuItem from './MenuItem.vue';
  import Chevron from './icons/Chevron.vue';
  import { useHeaderZIndex } from '@/shared/lib/useHeaderZIndex.ts';

  interface IProps {
    menu: IMenuItem[];
    title: string;
    routeStart: string;
    activeItemSlug?: string;
  }

  const props = defineProps<IProps>();

  const isOpen = ref(false);

  const { decreaseZIndex, increaseZIndex } = useHeaderZIndex();

  const close = () => {
    isOpen.value = false;

    increaseZIndex();
  };

  const open = () => {
    isOpen.value = true;
    decreaseZIndex();
  };
</script>

<style scoped lang="scss">
  .mobile-menu {
    position: sticky;
    top: 0;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    background: var(--alias-color-background-default);
  }

  .mobile-menu__title {
    @include typography.base-400-400-medium;
  }

  .modal-menu__title {
    @include typography.base-600-500-semi;
  }

  .mobile-menu-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-top: 8px;
  }

  .mobile-menu-item {
    @include typography.base-400-400-regular;
  }
</style>
